/* eslint-disable */ import { $DomainEntityReflection, EnhancedAliasReflection } from '@salsita-ai/platform-project-sdk/domain';
import { Admin, ConnectedDataConfig, DataTable, DummyDoNotUse, Preset, PresetCategory, PricingSettings, Recipe } from './admin-model/index.js';
export const constants = {};
const PresetCategoryExpressions = [
    '$isDraft',
    '$admin',
    '$presets'
];
const AdminExpressions = [
    '$pricingSettings',
    '$presets',
    '$presetCategories',
    '$recipes',
    '$connectedDataConfigs',
    '$dataTables'
];
const PricingSettingsExpressions = [
    '$admin'
];
const PresetExpressions = [
    '$admin',
    '$category',
    '$violations'
];
const RecipeExpressions = [
    '$admin'
];
const ConnectedDataConfigExpressions = [
    '$admin'
];
const DataTableExpressions = [
    '$admin'
];
export const $Admin = new $DomainEntityReflection('Admin', [
    ...AdminExpressions
]);
export const $Preset = new $DomainEntityReflection('Preset', [
    ...PresetExpressions
]);
export const $PresetCategory = new $DomainEntityReflection('PresetCategory', [
    ...PresetCategoryExpressions
]);
export const $Recipe = new $DomainEntityReflection('Recipe', [
    ...RecipeExpressions
]);
export const $ConnectedDataConfig = new $DomainEntityReflection('ConnectedDataConfig', [
    ...ConnectedDataConfigExpressions
]);
export const $DataTable = new $DomainEntityReflection('DataTable', [
    ...DataTableExpressions
]);
export const $DummyDoNotUse = new $DomainEntityReflection('DummyDoNotUse', []);
export const $PricingSettings = new $DomainEntityReflection('PricingSettings', [
    ...PricingSettingsExpressions
]);
export const $AnyDomainEntity = new EnhancedAliasReflection('$AnyDomainEntity', [
    Admin.type,
    Preset.type,
    PresetCategory.type,
    Recipe.type,
    ConnectedDataConfig.type,
    DataTable.type,
    DummyDoNotUse.type,
    PricingSettings.type
]);
export const $RootEntity = new EnhancedAliasReflection('$RootEntity', [
    Admin.type
]);
export const $CommonAdminEntity = new EnhancedAliasReflection('$CommonAdminEntity', [
    Admin.type,
    Preset.type,
    PresetCategory.type,
    Recipe.type,
    ConnectedDataConfig.type,
    DataTable.type
]);
export const $entityReflections = {
    Admin: $Admin,
    Preset: $Preset,
    PresetCategory: $PresetCategory,
    Recipe: $Recipe,
    ConnectedDataConfig: $ConnectedDataConfig,
    DataTable: $DataTable,
    DummyDoNotUse: $DummyDoNotUse,
    PricingSettings: $PricingSettings
};

//# sourceMappingURL=admin-enhanced-model.js.map